module.exports = __webpack_public_path__ + "static/media/SFProText-Heavy.6c498791.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SFPro/TrueType/SFProText-Heavy.ttf
// module id = 2556
// module chunks = 7